module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/currencies/currencies-show/currencies-show.component.scss
// module id = ./src/app/views/setting/currencies/currencies-show/currencies-show.component.scss
// module chunks = main